export const DOCS_URL = 'https://docs.chkk.io';

export const SECURITY_URL = `${DOCS_URL}/security`;
export const GLOSSARY_URL = `${DOCS_URL}/resources/glossary`;
export const TROUBLESHOOTING_URL = `${DOCS_URL}/resources/troubleshooting`;
export const CHKK_KUBERNETES_CONNECTOR_URL = `${DOCS_URL}/connectors/kubernetes`;
